import React from "react";
import { Card, Text, Link } from "@merge-api/merge-javascript-shared";
import {
  FieldMappingOptions,
  FieldMappingTarget,
  LinkedAccount,
} from "../../../../../../models/Entities";
import {
  CONFIGURATION_FIELD_MAPPINGS_TARGET_FIELDS_PATH,
  CONFIGURATION_COMMON_MODELS_PATH,
} from "../../../../../../router/RouterUtils";
import FieldMappingUnmappedTargetCard from "./FieldMappingUnmappedTargetCard";
import FieldMappingsMergeToIntegrationHeader from "../components/FieldMappingsMergeToIntegrationHeader";

type FieldMappingUnmappedTargetsForCommonModelProps = {
  commonModel: string;
  fieldMappingTargets: Array<FieldMappingTarget>;
  isRemoteDataEnabled: boolean;
  fieldMappingOptions: FieldMappingOptions;
  linkedAccount: LinkedAccount;
  isJmesPathDeprecationEnabled: boolean;
};

const FieldMappingUnmappedTargetsForCommonModel = ({
  commonModel,
  fieldMappingTargets,
  isRemoteDataEnabled,
  fieldMappingOptions,
  linkedAccount,
  isJmesPathDeprecationEnabled,
}: FieldMappingUnmappedTargetsForCommonModelProps) => {
  return (
    <Card>
      <div className="px-6 py-5 border-b border-gray-10">
        <Text variant="h4">{commonModel}</Text>
      </div>
      <div className="py-5 px-6">
        {isRemoteDataEnabled ? (
          fieldMappingTargets.length > 0 ? (
            <>
              <div className="mb-4">
                <FieldMappingsMergeToIntegrationHeader
                  integrationName={linkedAccount.integration.name}
                  integrationSquareImage={linkedAccount.integration.square_image}
                  organization={linkedAccount.organization}
                  isSingular={fieldMappingTargets.length == 1}
                />
              </div>
              <div className="flex flex-col gap-6">
                {fieldMappingTargets.map(
                  ({ field_key, field_description, id }: FieldMappingTarget) => {
                    return (
                      <FieldMappingUnmappedTargetCard
                        linkedAccount={linkedAccount}
                        fieldKey={field_key}
                        fieldDescription={field_description}
                        fieldMappingOptions={fieldMappingOptions}
                        commonModel={commonModel}
                        fieldMappingTargetId={id}
                        isJmesPathDeprecationEnabled={isJmesPathDeprecationEnabled}
                      />
                    );
                  },
                )}
              </div>
            </>
          ) : (
            <>
              This Common Model has no{" "}
              <Link href={CONFIGURATION_FIELD_MAPPINGS_TARGET_FIELDS_PATH} target="_blank">
                target fields
              </Link>
            </>
          )
        ) : (
          <>
            Enable{" "}
            <Link
              href={`${CONFIGURATION_COMMON_MODELS_PATH}/${linkedAccount.category}`}
              target="_blank"
            >
              Remote Data
            </Link>{" "}
            to create Field Mappings for this Common Model
          </>
        )}
      </div>
    </Card>
  );
};

export default FieldMappingUnmappedTargetsForCommonModel;
